import React from "react";
import { SectionTitle } from "../components";

export const Hobbies = () => {
  return (
    <div className="container">
      <div className="section odd hobbies">
        <SectionTitle title="Hobbies" />
        <p>Work in progress...</p>
      </div>
    </div>
  );
};
